
import { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import { useViewportHeight } from "@/hooks/useViewportHeight";

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { theme } = useThemeConfig();
  
  // Usa l'hook per gestire l'altezza dinamica del viewport
  useViewportHeight();

  const handleMenuClick = () => {
    setIsSidebarOpen(true);
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div
      className="min-viewport-height viewport-transition"
      style={{ backgroundColor: theme.backgroundColor }}
    >
      <Sidebar isOpen={isSidebarOpen} onClose={handleSidebarClose} />
      
      {/* Container principale che usa l'altezza dinamica del viewport */}
      <main className="w-full min-viewport-height">
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
